import { RuleTypeEnum } from "../../../domain/RuleType";
import { EnrichedWebCategoryRuleValue } from "../../../domain/ruleValue/WebCategoryRuleValue";
import { RuleValueStore, SerializedRuleValueStore } from "../RuleValueStore";

export class WebCategoryRuleValueStore implements RuleValueStore<RuleTypeEnum.WEB_CATEGORY> {
    allowedWebCategoryFilterKeys: Set<number>;
    deniedWebCategoryFilterKeys: Set<number>;

    constructor() {
        this.allowedWebCategoryFilterKeys = new Set();
        this.deniedWebCategoryFilterKeys = new Set();
    }

    add(enrichedRuleValue: EnrichedWebCategoryRuleValue): void {
        if (enrichedRuleValue.action.isAllow()) {
            for (const filterKey of enrichedRuleValue.filterKeys.getValue()) {
                this.allowedWebCategoryFilterKeys.add(filterKey);
            }
        } else {
            for (const filterKey of enrichedRuleValue.filterKeys.getValue()) {
                this.deniedWebCategoryFilterKeys.add(filterKey);
            }
        }
    }

    serialize(): SerializedRuleValueStore<RuleTypeEnum.WEB_CATEGORY> {
        const data: SerializedWebCategoryRuleValueStoreData = {
            allowedWebCategoryFilterKeys: Array.from(this.allowedWebCategoryFilterKeys),
            deniedWebCategoryFilterKeys: Array.from(this.deniedWebCategoryFilterKeys),
        };
        return {
            type: RuleTypeEnum.WEB_CATEGORY,
            data: data,
        };
    }

    fromSerialized(serialized: SerializedRuleValueStore<RuleTypeEnum.WEB_CATEGORY>): void {
        this.allowedWebCategoryFilterKeys = new Set(serialized.data.allowedWebCategoryFilterKeys);
        this.deniedWebCategoryFilterKeys = new Set(serialized.data.deniedWebCategoryFilterKeys);
    }

    evaluateWebCategory(webCategoryFilterKeys: number[]): WebCategoryRuleValueStoreEvaluationResult {
        if (webCategoryFilterKeys.length === 0) return "NO_MATCH";

        const webCategoryFilterKeysSet: Set<number> = new Set(webCategoryFilterKeys);
        const allowedOverlap: boolean = this.hasOverlap(webCategoryFilterKeysSet, this.allowedWebCategoryFilterKeys);
        if (allowedOverlap) return "ALLOWED";

        const deniedOverlap: boolean = this.hasOverlap(webCategoryFilterKeysSet, this.deniedWebCategoryFilterKeys);
        if (deniedOverlap) return "DENIED";

        return "NO_MATCH";
    }

    private hasOverlap(a: Set<number>, b: Set<number>): boolean {
        const small: Set<number> = a.size < b.size ? a : b;
        const large: Set<number> = a.size < b.size ? b : a;

        for (const value of small) {
            if (large.has(value)) {
                return true;
            }
        }

        return false;
    }
}

export interface SerializedWebCategoryRuleValueStoreData {
    allowedWebCategoryFilterKeys: number[];
    deniedWebCategoryFilterKeys: number[];
};

export type WebCategoryRuleValueStoreEvaluationResult = "ALLOWED" | "DENIED" | "NO_MATCH"